import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CfgService } from 'src/app/cfg/cfg.service';

export class ShowPowerBiCfg {
  public show: string;
}

@Injectable({
  providedIn: 'root'
})
export class ShowPowerBiCfgService extends CfgService<ShowPowerBiCfg> {
  protected exclude: boolean = true;

  constructor(httpBackend: HttpBackend) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/showPowerbi.cfg.json`;
  }
}
